/* eslint no-console: 0 */
// Run this example by adding <%= javascript_pack_tag 'hello_vue' %> (and
// <%= stylesheet_pack_tag 'hello_vue' %> if you have styles in your component)
// to the head of your layout file,
// like app/views/layouts/application.html.erb.
// All it does is render <div>Hello Vue</div> at the bottom of the page.

import Vue from 'vue'
import App from '../src/app.vue'
import ElementUI from 'element-ui'
import vSelect from 'vue-select'
import Pagination from '../src/components/Pagination'
import locale from 'element-ui/lib/locale/lang/ja'
import 'element-ui/lib/theme-chalk/index.css'
import 'vue-select/dist/vue-select.css'
import '../src/assets/style.scss'
import '../src/assets/permalink.scss'
import router from '../src/router'
import store from '../src/store'
import { abilitiesPlugin } from '@casl/vue';
import permissionService from "../src/services/permission_service";
import { datadogRum } from '@datadog/browser-rum';


Vue.use(ElementUI, { locale })
Vue.component('pagination', Pagination)
Vue.component('v-select', vSelect)
Vue.use(abilitiesPlugin, {
  useGlobalProperties: true
})

document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('app')) {
    permissionService.setPermissions().then(() => {
      new Vue({
        el: '#app',
        router,
        store,
        render: h => h(App)
      }).$mount()
    })
  }
  if (document.getElementById('permalink')) {
    new Vue({
      el: '#permalink',
      router,
      store,
      render: h => h(App)
    }).$mount()
  } else if (document.getElementById('booking_edit')) {
    new Vue({
      el: '#booking_edit',
      router,
      store,
      render: h => h(App)
    }).$mount()
  }
})

// Datadog RUM
// https://docs.datadoghq.com/ja/real_user_monitoring/browser/
if (process.env.NODE_ENV === 'production') {
  (function (h, o, u, n, d) {
    h = h[d] = h[d] || {
      q: [], onReady: function (c) {
        h.q.push(c)
      }
    }
    d = o.createElement(u);
    d.async = 1;
    d.src = n
    n = o.getElementsByTagName(u)[0];
    n.parentNode.insertBefore(d, n)
  })(window, document, 'script', 'https://www.datadoghq-browser-agent.com/us1/v5/datadog-rum.js', 'DD_RUM')
  window.DD_RUM.onReady(function () {
    window.DD_RUM.init({
      // ブラウザに露出する値なのでベタ書きで問題なし
      clientToken: 'pube43ad7922ca25b5cf0000e84011f9f4f',
      applicationId: '3f0da1cc-3420-4c79-aebc-8969cee32847',
      // `site` refers to the Datadog site parameter of your organization
      // see https://docs.datadoghq.com/getting_started/site/
      site: 'datadoghq.com',
      service: 'carecle',
      env: 'production',
      sessionSampleRate: 30,
      sessionReplaySampleRate: 10,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
    });
  })
}
